export default __webpack_public_path__ + "static/staking-icon-137fa8b6257f4303207b737d16503049.svg";